import { useGetTagDetailQuery } from '../../../api/ua-insights'
import { useUAInsightsParams, useUAInsightsScope } from './useUAInsightsNavigation'

/**
 * Tag detail (creatives, games, network breakdown), narrowed by the dialog's
 * optional `genreId` / `gameId` params. The tag-games dialog reads the same
 * query, so opening one after the other costs no extra request.
 */
export const useCreativeTagDetails = (tagId: string | null) => {
  const { params } = useUAInsightsParams()
  const { networkId, month } = useUAInsightsScope()
  const { data, isFetching, isError, refetch } = useGetTagDetailQuery(
    {
      tagId: tagId ?? '',
      networkId: networkId ?? undefined,
      genreId: params.genreId ?? undefined,
      gameId: params.gameId ?? undefined,
      month: month ?? undefined,
    },
    { skip: !tagId }
  )
  return { data, isLoading: isFetching, isError, refetch }
}
